export default {
    user:{
        currentUser: null,
        isAuthenticated: false,
        isAuthenticating: false,
        authError: null,
        accountList: [],
        systemOfUnits: null
    },
    icnSearch:{
        list: [],
        totalCount: 0,
        item: null,
        error: null,
        isSearching: false,
        mapList: [],
        mapTotalCount: 0,
    },
    icnPlusSearch:{
        item: null,
        error: null,
        isSearching: false
    },
    icnAccelerationSearch:{
        list: [],
        error: null,
        isSearching: false
    },
    icnSpeedSearch:{
        list: [],
        error: null,
        isSearching: false
    },
    icnBomListSearch:{
        list: [],
        error: null,
        isSearching: false
    },
    eventClassification:{
        error: null,
        isUpdating: false
    },
    deviceSearch:{
        item: null,
        totalCount: 0,
        list: [],
        error: null,
        isSearching: false
    },
    accountSearch:{
        item: null,
        totalCount: 0,
        list: [],
        error: null,
        isSearching: false
    },
    systemUnitsSearch:{
        item: null,
        error: null,
        isSearching: false
    },
    crashboxxPdofSearch: {
        binaries: null,
        error: null,
        isSearching: false
    },
    crashboxxBomPredictiveSearch: {
        binaries: null,
        error: null,
        isSearching: false
    },
    crashboxxFiles: {
        singleExcel: {
            error: null,
            isLoading: false
        },
        singlePdf: {
            error: null,
            isLoading: false
        },
        singleCsv: {
            error: null,
            isLoading: false
        },
        listExcel: {
            error: null,
            isLoading: false
        },
        listPdf: {
            error: null,
            isLoading: false
        },
        listCsv: {
            error: null,
            isLoading: false
        },
        allListExcel: {
            error: null,
            isLoading: false
        },
        allListPdf: {
            error: null,
            isLoading: false
        },
        allListCsv: {
            error: null,
            isLoading: false
        }

    },
    googleSearch:{
        dstOffset: null,
        rawOffset: null,
        error: null,
        isSearching: false
    },
    jasperReport:{
        loginCompleted: false,
        optionsCompleted: false,
        isLoading: false,
        error: null,
        options: null
    },
    ajaxCallsInProgress: 0,
    grid:{
        rowIndex: 0
    },
    appData:{
        selectedApplication: null,
        severityCodeList:[
            {id:0, code: 'AllCrashes', localizationKey: 'SeverityCodeList.All'},
            {id:1, code: 'AllCrashesButNonNonCrash', localizationKey: 'SeverityCodeList.AllButNonCrash'},
            {id:2, code: 'NonCrash', localizationKey: 'SeverityCodeList.NonCrash'},
            {id:3, code: 'VeryLight', localizationKey: 'SeverityCodeList.VeryLight'},
            {id:4, code: 'Light', localizationKey: 'SeverityCodeList.Light'},
            {id:5, code: 'Moderate', localizationKey: 'SeverityCodeList.Moderate'},
            {id:6, code: 'Heavy', localizationKey: 'SeverityCodeList.Heavy'},
            {id:7, code: 'VeryHeavy', localizationKey: 'SeverityCodeList.VeryHeavy'},
        ],
        eventClassificationList: [
            {id:0, code: 'UNCONFIRMED', localizationKey: 'EventClassificationList.UNCONFIRMED'},
            {id:1, code: 'CONFIRMED', localizationKey: 'EventClassificationList.CONFIRMED'},
            {id:2, code: 'TECHNICIAN_INSTALL', localizationKey: 'EventClassificationList.TECHNICIAN_INSTALL'},
            {id:3, code: 'DE_INSTALL', localizationKey: 'EventClassificationList.DE_INSTALL'},
            {id:4, code: 'IMPROPER_INSTALLATION', localizationKey: 'EventClassificationList.IMPROPER_INSTALLATION'},
            {id:5, code: 'LOOSE_INSTALL', localizationKey: 'EventClassificationList.LOOSE_INSTALL'},
            {id:6, code: 'FALSE_POSITIVE', localizationKey: 'EventClassificationList.FALSE_POSITIVE'},
            {id:7, code: 'TESTING', localizationKey: 'EventClassificationList.TESTING'},
        ]
    },
};


// WEBPACK FOOTER //
// ./src/reducers/initialState.js